import type { RouteRecordRaw } from 'vue-router';
import { STUDIO_CRUD } from '@core/models/permissions';
import { permissionRouteGuard } from '@core/route-guards';

export const SYSTEM_ADMIN_HOME = 'systemadmin-home';
export const SYSTEM_ADMIN_STUDIOS = 'systemadmin-studios';
export const SYSTEM_ADMIN_USERS = 'systemadmin-users';
export const SYSTEM_ADMIN_SYSTEM = 'systemadmin-system';
export const SYSTEM_ADMIN_REPORTS = 'systemadmin-reports';
export const SYSTEM_ADMIN_FEATURES = 'systemadmin-features';
export const SYSTEM_ADMIN_PROFILE = 'systemadmin-profile';

export const SYSTEM_ADMIN_PRODUCT_ITEMS = 'systemadmin-product-items';
export const SYSTEM_ADMIN_PRODUCT_TAGS = 'systemadmin-product-tags';

const routes: RouteRecordRaw[] = [
  {
    path: '/admin',
    component: () => import('./layouts/AdminLayout.vue'),
    beforeEnter: permissionRouteGuard([STUDIO_CRUD]),
    children: [
      {
        path: 'home',
        alias: '/admin',
        name: SYSTEM_ADMIN_HOME,
        component: () => import('./pages/HomePage.vue'),
      },
      {
        path: 'profile',
        name: SYSTEM_ADMIN_PROFILE,
        component: () => import('../studioadmin/pages/ProfilePage.vue'),
      },
      {
        path: 'studios',
        name: SYSTEM_ADMIN_STUDIOS,
        component: () => import('./pages/StudioListingPage.vue'),
      },
      {
        path: 'features',
        name: SYSTEM_ADMIN_FEATURES,
        component: () => import('./pages/Features/FeatureListingPage.vue'),
      },
      {
        path: 'users',
        name: SYSTEM_ADMIN_USERS,
        component: () => import('./pages/Users/UsersPage.vue'),
      },
      {
        path: 'reports',
        name: SYSTEM_ADMIN_REPORTS,
        component: () => import('./pages/Reports/ReportsTabPage.vue'),
      },
      {
        path: 'system',
        children: [
          {
            path: '',
            name: SYSTEM_ADMIN_SYSTEM,
            component: () => import('./pages/System/SystemPage.vue'),
          },
          {
            path: 'products',
            component: () => import('./pages/System/ProductsPage.vue'),
          },
          {
            path: 'shipping-options',
            component: () => import('./pages/System/ShippingOptionsPage.vue'),
          },
          {
            path: 'order-services',
            component: () => import('./pages/System/OrderServicesPage.vue'),
          },
          {
            path: 'order-errors',
            component: () => import('./pages/System/OrderErrorsPage.vue'),
          },
          {
            path: 'vertex-logs',
            component: () => import('./pages/System/OrderVertexLogsPage.vue'),
          },
          {
            path: 'sendgrid-logs',
            component: () => import('./pages/System/SendGridLogsPage.vue'),
          },
          {
            path: 'galleries-processing',
            component: () => import('./pages/System/GalleriesProcessingPage.vue'),
          },
          {
            path: 'taxes',
            component: () => import('./pages/System/TaxesPage.vue'),
          },
          {
            path: 'configuration',
            component: () => import('./pages/System/SystemConfigurationPage.vue'),
          },
          {
            path: 'product-catalog',
            component: () => import('./pages/System/ProductCatalogPage.vue'),
            children: [
              {
                path: '',
                name: SYSTEM_ADMIN_PRODUCT_ITEMS,
                component: () => import('./pages/System/ProductCatalogItemsPage.vue'),
              },
              {
                path: 'tags',
                name: SYSTEM_ADMIN_PRODUCT_TAGS,
                component: () => import('./pages/System/ProductCatalogTagsPage.vue'),
              },
            ],
          },
          {
            path: 'entry',
            component: () => import('./pages/System/EntryToolsPage.vue'),
          },
          {
            path: 'watermarks',
            component: () => import('./pages/System/WatermarksPage.vue'),
          },
          {
            path: 'defined-fields',
            component: () => import('./pages/System/DefinedFieldsPage.vue'),
          },
          {
            path: 'workflows',
            component: () => import('./pages/System/WorkflowsPage.vue'),
          }
        ],
      },
    ],
  },
];
export default routes;
